import { render } from "./DevolucaoComprasListagem.vue?vue&type=template&id=37db4f3c&scoped=true&ts=true"
import script from "./DevolucaoComprasListagem.vue?vue&type=script&lang=ts"
export * from "./DevolucaoComprasListagem.vue?vue&type=script&lang=ts"

import "./DevolucaoComprasListagem.vue?vue&type=style&index=0&id=37db4f3c&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37db4f3c"]])

export default __exports__